// Sourced from package.json through webpack

// noinspection JSUnresolvedVariable
export default _app_package_info;
